import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { ApiService } from '../../../../services/api/api.service';
import { NbToastrService } from '@nebular/theme';
import { EmailLookupComponent } from '../../../shared/components/email-lookup/email-lookup.component';

@Component({
  selector: 'rfq-select-items',
  templateUrl: './rfq-select-items.component.html',
  styleUrls: ['./rfq-select-items.component.css']
})
export class RfqSelectItemsComponent implements OnInit {
  private requisitionId: any;
  private requisitionPartialId: any;
  public loading: boolean;
  public items: any;
  public addGlobalEmail: boolean;
  public globalEmail: any;
  public logs: any = new Array();
  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef,
    private apiService: ApiService,
    private messageService?: NbToastrService,
    private dialogService?: DialogService) {
    if (config && config.data && config.data.requisitionId) {
      this.requisitionId = config.data.requisitionId;
      this.loadRfq();
    }



  }

  ngOnInit() {
  }

public openEmailLookup(){
  const ref = this.dialogService.open(EmailLookupComponent, {
    header: `Email address lookup`,
    width: '50%'
  });
  ref.onClose.subscribe((emails) => {
    if (emails){
      debugger;
   emails.forEach(email=>{
    this.items.forEach(o => {
      o.partyContacts.push({ selected: true, value: email });
    });
   })
      
  }
  });
}

  public loadRfq() {
    this.loading = true;

    this.items = new Array();
    this.apiService.get(`/api/requisition/rfq/${this.requisitionId}`)
      .subscribe(results => {
        this.items = results;
        this.items.forEach(o => {
          if (!o.partyContacts)
            o.partyContacts = new Array();
        });
        this.loading = false;

        if (results.length == 0)
          this.ref.close();
      }, err => {
        this.messageService.danger("Could not load", "Action");
        this.loading = false;
      });
  }


  public save() {
    this.ref.close(this.getFormattedData());
  }

  public send() {
    this.loading = true;
    this.logs = new Array();
    this.apiService.post(`/api/requisition/requestRfq/${this.requisitionId}`, { items: this.getFormattedData() })
      .subscribe(results => {
        this.loading = false;
        if (results && results.length > 0) {
          var failed = results.filter(o => { return !o.success; });
          if (failed.length > 0) {
            this.logs = results;
          }
          else {
            this.messageService.success(results.length + " email(s) sent successfully", "Action");
            this.ref.close();
          }
        }
        else this.messageService.success("Emails sent successfully", "Action");
      }, err => {
        this.messageService.danger("Could not load", "Action");
        this.loading = false;
      });
  }

  public cancel() {
    this.ref.close();
  }

  public addGlobalEmailToItems() {
    this.items.forEach(o => {
      o.partyContacts.push({ selected: true, value: this.globalEmail });
    });
    this.globalEmail = '';
    this.addGlobalEmail = false;
  }

  public getFormattedData() {
    return this.items.filter(i => {
      return i.selected && i.partyContacts && i.partyContacts.length > 0
    }).map(o => ({
      qty: o.qty, description: o.nonStandardItemDescription, comments: o.comments, supplierId: o.supplierId, emails: o.partyContacts.filter(function (i) {
        return i.selected
      }).map(o => o.value)
    }))
  }

}
